<template>
  <div class="standard-login"  :class="{ 'transborder-login': isTransborder === 'true' }">
    <FormCard
    :isTransborderCustomer="isTransborder"
    />
  </div>
</template>

<script>
import FormCard from "./components/FormCard.vue";

export default {
  name: "StandardLogin",
  components: {
    FormCard,
  },
  data() {
    return {
      isTransborder: process.env.VUE_APP_TRANSBORDER_APP,
    };
  },
  created() {
    /* eslint-disable global-require */
    const link = document.querySelector("link[rel~='icon']");
    const logoUrl = require("../../assets/images/letter-p.png");
    const transborderLogo = require("../../assets/images/Transborder-favicon.jpeg");
    link.href = this.isTransborder === "false" ? logoUrl : transborderLogo;
  },
};
</script>

<style lang="scss" scoped>
.standard-login {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url("../../assets/images/camion-autonomo-de-aurora.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center;
}

.transborder-login {
  width: 100%;
  height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: url("../../assets/images/Transborder-background.jpg");
  background-size: cover;
  background-position: center;
}
</style>
